import { Head } from "@inertiajs/react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import AppLayout from "@/layouts/app-layout";
import { pricesPath } from "@/routes";
import type { BreadcrumbItem, PagyMetadata } from "@/types";

import type { PriceHistoryRecord } from "./columns";
import { PricesDataTable } from "./data-table";

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Histórico de Precios",
    href: pricesPath(),
  },
];

interface PricesProps {
  data: {
    prices: PriceHistoryRecord[];
    pagy: PagyMetadata;
  };
  filters: Record<string, string | number | undefined>;
}

export default function Prices({ data, filters }: PricesProps) {
  const { prices, pagy } = data;

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Histórico de Precios" />
      <div className="flex h-full flex-1 flex-col gap-4 p-4">
        <div className="flex flex-col space-y-2">
          <h2 className="text-2xl font-bold">Histórico de Precios</h2>
          <p className="text-muted-foreground">
            Consulta el historial completo de precios registrados en el sistema
          </p>
        </div>

        <Alert>
          <AlertDescription>
            <strong>Cotizado:</strong> Precio ofrecido por un proveedor en una
            cotización. <br />
            <strong>Compra:</strong> Precio seleccionado para compra en una
            solicitud de compra.
          </AlertDescription>
        </Alert>

        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Total: {pagy.count} registros de precios
          </div>
        </div>

        <PricesDataTable prices={prices} pagy={pagy} filters={filters} />
      </div>
    </AppLayout>
  );
}
